// extracted by mini-css-extract-plugin
export var background = "solutionListing-module--background--7ec01";
export var head = "solutionListing-module--head--f2eae";